// extracted by css-extract-rspack-plugin
export default {"wrapper":"SeparatorV8_wrapper__ZQMd4","enabled":"SeparatorV8_enabled__JGaIT","separator":"SeparatorV8_separator__rqQwg","active":"SeparatorV8_active__OPZlj"};